if (!customElements.get('lcdh-navbar')) {
  customElements.define('lcdh-navbar', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.mobile = this.querySelector('.nv-mobile');
      this.onScroll = () => { this.dataset.scrolled = String(window.scrollY > 24); };
      this.onScroll();
      window.addEventListener('scroll', this.onScroll, { passive: true, signal });
      this.addEventListener('keydown', e => {
        if (e.key !== 'Escape') return;
        const open = [...this.querySelectorAll('details[open]')].reverse();
        if (open.length) {open[0].open = false;open[0].querySelector('summary').focus();e.stopPropagation();}
      }, {signal});
      this.addEventListener('toggle', e => {
        if (!(e.target instanceof HTMLDetailsElement)) return;
        const summary = e.target.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', String(e.target.open));
        if(e.target.open && e.target.classList.contains('nv-dropdown')) {
          const nav = e.target.closest('nav');
          nav?.querySelectorAll('details[open]').forEach(other => {if(other !== e.target) other.open = false;});
        }
      }, {capture:true,signal});
      document.addEventListener('pointerdown', e => {
        if(!this.contains(e.target)) this.closeMenus();
      }, {signal});
      this.addEventListener('click', e => {if(e.target.closest('a')) this.closeMenus();}, {signal});
      this.addEventListener('focusout', e => {if(e.relatedTarget && !this.contains(e.relatedTarget)) this.closeMenus();}, {signal});
      this.fit = () => {
        if (!this.isConnected) return;
        this.classList.remove('nv-compact');
        const nav = this.querySelector('.nv-desktop');
        if(!nav || getComputedStyle(nav).display === 'none') return;
        const inner = this.querySelector('.nv-inner');
        const brand = this.querySelector('.nv-brand');
        const actions = this.querySelector('.nv-actions');
        const style = getComputedStyle(inner);
        const needed = nav.scrollWidth + brand.offsetWidth + actions.offsetWidth + parseFloat(style.columnGap)*2 + parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
        this.classList.toggle('nv-compact',needed > inner.clientWidth + 1);
      };
      this.observer = new ResizeObserver(entries => {
        const width=entries[0].contentRect.width;
        if(width !== this.lastWidth){this.lastWidth=width;this.fit();}
      });
      this.observer.observe(this);
      document.fonts.ready.then(() => this.fit());
      this.fit();
    }
    closeMenus(){this.querySelectorAll('details[open]').forEach(d=>{d.open=false;});}
    disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();}
  });
}
